import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export const Card = ({ className, children, ...props }: CardProps) => {
  return (
    <div
      className={cn(
        'bg-slate-900/80 backdrop-blur-sm border border-slate-800 rounded-xl p-6 shadow-2xl',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
